import "./BoatCard.scss";
import { formatAmount, startingPrice } from "../Home/activityPrice";

const BACKEND = process.env.REACT_APP_BACKEND;

function ActivityCard({ activity, onEdit, onDelete }) {
  const from = startingPrice(activity.prices);
  const priceText = from
    ? `${from.isFrom ? "From " : ""}${formatAmount(from)}${!from.isFrom && from.unit ? ` / ${from.unit}` : ""}`
    : activity.price;

  return (
    <div className="admin-card">
      {activity.image ? (
        <img
          src={`${BACKEND}/images/activities/${activity.image}`}
          alt={activity.name}
        />
      ) : (
        <div className="no-image">No image</div>
      )}
      <h3>{activity.name}</h3>
      <p className="boat-meta">{priceText}</p>
      {(onEdit || onDelete) && (
        <div className="card-actions" style={{ marginTop: "auto", paddingTop: "12px" }}>
          {onEdit && <button className="edit-btn" onClick={() => onEdit(activity)}>Edit</button>}
          {onDelete && <button className="delete-btn" onClick={() => onDelete(activity._id)}>Delete</button>}
        </div>
      )}
    </div>
  );
}

export default ActivityCard;
